import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormText, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { inputPropTypes, metaPropTypes } from './InputPropTypes';

class TextAreaInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.input.value || '',
    };
  }

  componentDidUpdate(prevProps) {
    const prevValue = prevProps.input.value;
    const newValue = this.props.input.value;

    if (prevValue !== newValue) {
      this.setState({
        value: newValue || '',
      });
    }
  }

  onChange = (e) => {
    const { input: { onChange } } = this.props;

    const newValue = e.target.value || '';

    this.setState({ value: newValue });

    if (onChange) onChange(newValue);
  };

  render() {
    const {
      id,
      input,
      name,
      placeholder,
      className,
      meta: { touched, error, warning },
      disabled,
      invalid,
      append,
      maxLength,
      size,
    } = this.props;

    const { value } = this.state;

    let appendButton = null;
    if (append) {
      appendButton = (
        <InputGroupAddon addonType="append">
          {append}
        </InputGroupAddon>
      );
    }

    return (
      <div>
        <InputGroup>
          <Input
            id={id}
            type="textarea"
            name={name}
            value={value}
            onChange={this.onChange}
            onBlur={input.onBlur}
            placeholder={placeholder}
            disabled={disabled}
            invalid={invalid}
            className={className}
            bsSize={size}
            maxLength={maxLength}
          />
          {appendButton}
        </InputGroup>

        {maxLength > 0 && (
          <FormText color="secondary" className="float-right">
            {maxLength - value.length} de {maxLength} caracteres
          </FormText>
        )}

        <FormText color="danger">
          {touched &&
            ((error && <span>{error}</span>) ||
              (warning && <span>{warning}</span>))}
        </FormText>
      </div>
    );
  }
}

TextAreaInput.propTypes = {
  id: PropTypes.string,
  input: inputPropTypes.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  meta: metaPropTypes.isRequired,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  append: PropTypes.element,
  maxLength: PropTypes.number,
  size: PropTypes.string,
};

TextAreaInput.defaultProps = {
  id: null,
  name: '',
  placeholder: '',
  className: '',
  disabled: false,
  invalid: false,
  append: null,
  maxLength: 200,
  size: 'md',
};

export default TextAreaInput;